module.exports = __webpack_public_path__ + "resources/img/FaceTec-logo-highres.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/FaceTec-logo-highres.png
// module id = 889
// module chunks = 0